<template>
  <div id="overview-report">
    <div id="overview-report-header">
      <v-btn flat dark :to="`/bot/${activeBot.code}`" class="text-capitalize">
        <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
        back
      </v-btn>
      <span id="overview-report-header-title">{{$t('overviewReport.title')}}</span>
      <div id="overview-report-header-bot-list">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on" id="overview-report-header-active-bot">
              <span>{{ activeBot ? activeBot.name : '' }}</span>
              <v-icon color="#fff">mdi-chevron-down</v-icon>
            </div>
          </template>
          <div id="overview-report-header-bot-list-menu">
            <v-list>
              <v-list-tile
                  v-for="bot in botList"
                  :key="bot.code"
                  @click="onChangeBot(bot)"
                  :class="activeBot.code === bot.code ? 'active' : ''"
              >
                <v-list-tile-title>{{ bot.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </div>
        </v-menu>
      </div>
    </div>
    <div id="overview-report-body" class="fill-height">
      <div class="overview-report-drawer">
        <router-link :to="item.to" active-class="drawer-item-active" v-for="item in drawerItems"
                     v-bind:key="item.title">
          <div class="drawer-item">
            <v-icon size="24">{{ item.icon }}</v-icon>
          </div>
        </router-link>
        <div style="flex-grow: 1; width: 100%; background-color: white"></div>
      </div>
      <div class="overview-report-content">
        <OverviewReportFilterBox @onRefresh="onRefresh"/>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import ActionTypes from "@/store/ActionTypes";
import BotService from "@/services/bot.service";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import OverviewReportFilterBox from "@/views/overview-report/OverviewReportFilterBox";
import StaffService from "@/services/staff.service";

export default {
  name: "OverviewReport",
  components: {OverviewReportFilterBox},
  async mounted() {
    let has_permission = await this.hasPermission();
    let botCode = this.$route.params.bot_code;
    if (botCode) {
        await BotService.getAndSetBotConfig(botCode);
    }
    if(has_permission && this.botConfig['allowOverviewReport']){
      this.initBotStaffList();
      this.fetchAutoAssignStatusManage();
      this.polling()
    }
    else {
      this.$router.push('/forbidden')
    }
  },
  computed: {
    ...mapState(['botStaffList', 'user']),
    ...mapState('config', ['botConfig']),

    activeBot() {
      const botCode = this.$route.params.bot_code;
      if (botCode) {
        let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
        return bot ? {code: bot.bot_code, name: bot.bot_name} : {}
      }
      return {}
    },
    botList() {
      return _.map(this.botStaffList, o => {
        return {name: o.bot_name, code: o.bot_code}
      });
    },
    drawerItems() {
      return [
        {
          title: 'Overview',
          icon: 'mdi-chart-bar',
          to: `/overview-report/${this.activeBot.code}/dashboard`
        },
        {
          title: 'Details',
          icon: 'mdi-format-list-bulleted',
          to: `/overview-report/${this.activeBot.code}/details`
        },
        {
          title: 'Live Support',
          icon: 'mdi-headset',
          to: `/overview-report/${this.activeBot.code}/live-support`
        }
      ]
    }
  },
  methods: {
    ...mapActions('overviewReport', ['fetchAutoAssignStatusManage', 'fetchOverviewReport']),
    async hasPermission(){
      return await StaffService.checkStaffHasRole(this.$route.params.bot_code, this.user.id, [10, 9, 5]);
    },
    onChangeBot(bot) {
      this.$store.commit(ActionTypes.BOT, bot)
      this.$router.push('/overview-report/' + bot.code)
    },
    initBotStaffList() {
      if (this.botStaffList.length < 1) {
        this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
      }
    },
    polling() {
      this.fetchOverviewReport()
      setTimeout(this.polling, 60000)
    },
    onRefresh() {
      this.fetchOverviewReport();
      this.fetchAutoAssignStatusManage();
    }
  },
}
</script>

<style scoped lang="scss">
@import "components/style/overview-report";
</style>